import React__default from 'react';
import { FlexBox } from '../shared/components/FlexBox.mjs';
import { SettingsContainer } from '../components/SettingsContainer.mjs';
import { Typography } from '../components/Typography.mjs';
import { DangerZoneSection } from './SCIMConnectionDangerZoneSection.mjs';
import { DetailsSection } from './SCIMConnectionDetailsSection.mjs';
import { RoleAssignmentsSection } from './SCIMConnectionRoleAssignmentsSection.mjs';
import { TokenRotationSection } from './SCIMConnectionTokenRotationSection.mjs';
import { useScimRouterController } from './SCIMRouter.mjs';

const SCIMConnectionDetailsScreen = ({ connection })=>{
    const { useBlockNavigation } = useScimRouterController();
    return /*#__PURE__*/ React__default.createElement(FlexBox, {
        gap: 3,
        flexDirection: "column"
    }, /*#__PURE__*/ React__default.createElement(Typography, {
        variant: "h1"
    }, "SCIM"), /*#__PURE__*/ React__default.createElement(SettingsContainer, {
        title: "Details",
        hasCTA: false,
        useBlockNavigation: useBlockNavigation
    }, /*#__PURE__*/ React__default.createElement(DetailsSection, {
        connection: connection
    })), /*#__PURE__*/ React__default.createElement(RoleAssignmentsSection, {
        connection: connection,
        useBlockNavigation: useBlockNavigation
    }), /*#__PURE__*/ React__default.createElement(SettingsContainer, {
        title: "Token Rotation",
        hasCTA: false,
        useBlockNavigation: useBlockNavigation
    }, /*#__PURE__*/ React__default.createElement(TokenRotationSection, {
        connection: connection
    })), /*#__PURE__*/ React__default.createElement(DangerZoneSection, {
        connection: connection
    }));
};

export { SCIMConnectionDetailsScreen };
//# sourceMappingURL=SCIMConnectionDetailsScreen.mjs.map
